import React from 'react';
import createSvgIcon from '../createNewIcon.js';
const Trash = createSvgIcon(React.createElement(React.Fragment, null,
    React.createElement("path", { d: "M7.2,22.2c-1.3,0-2.5-1-2.7-2.4L3.7,8.9l2-0.2l0.9,10.8c0,0.3,0.4,0.6,0.8,0.6l9.3,0c0.4,0,0.8-0.3,0.8-0.6\n\t\t    l0.9-10.8l2,0.2l-0.9,10.8c-0.2,1.5-1.4,2.5-2.8,2.4l-9.2,0C7.3,22.2,7.3,22.2,7.2,22.2z" }),
    React.createElement("path", { d: "M17,5V3c0-1.1-0.9-2-2-2H9C7.9,1,7,1.9,7,3v2H2v2h20V5H17z M9,3h6v2H9V3z" })), 'Trash');
export default Trash;
